import React from 'react';
import { MarketButton, MarketContentCard } from '@market/react';
import { ReactComponent as FrontCardImage } from 'images/checking/front-card.svg';
import { ReactComponent as FrontBackCardImage } from 'images/checking/front-back-card.svg';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  column: {
    float: 'left',
  },
  contentCard: {
    padding: '0',
    border: `1px solid ${theme.color.gray['15']}`,
  },
  imageContainer: {
    paddingBottom: 25,
    paddingTop: 25,
  },
  left: {
    width: '31%',
    borderTopLeftRadius: '5px',
    borderBottomLeftRadius: '5px',
    textAlign: 'center',
  },
  right: {
    width: '59%',
    paddingLeft: 32,
  },
  row: {
    width: '100%',
    height: '100%',
    display: 'table',
  },
  subtext: {
    paddingTop: 8,
    color: '#0000008C',
    paddingBottom: 8,
  },
}));

export const ImageOptions = {
  FrontCard: 'Front card',
  FrontBackCard: 'Front and back card',
};

const image = (type) => {
  switch (type) {
    case ImageOptions.FrontCard: {
      return <FrontCardImage />;
    }
    case ImageOptions.FrontBackCard: {
      return <FrontBackCardImage />;
    }
    default: {
      return null;
    }
  }
};

const ImageBanner = (props) => {
  const {
    backgroundColor,
    backgroundColorGradient,
    buttonText,
    headerText,
    imageType,
    onButtonClick,
    subtext,
  } = props;

  const classes = useStyles(backgroundColor);

  return (
    <MarketContentCard className={`${classes.contentCard}`}>
      <div className={`${classes.row}`}>
        <div
          className={`${classes.left} ${classes.column}`}
          style={{
            backgroundColor: `${backgroundColor}`,
            ...(backgroundColorGradient
              ? {
                  backgroundImage: `linear-gradient(to right, ${backgroundColor}, white`,
                }
              : {}),
          }}
        >
          <div className={`${classes.imageContainer}`}>{image(imageType)}</div>
        </div>
        <div className={`${classes.right} ${classes.column}`}>
          <p className="heading-20" style={{ paddingTop: 24 }}>
            {headerText}
          </p>
          <p className={`${classes.subtext} paragraph-20`}> {subtext} </p>
          <MarketButton onClick={onButtonClick} rank="primary">
            {buttonText}
          </MarketButton>
        </div>
      </div>
    </MarketContentCard>
  );
};

export default ImageBanner;
